import { render, staticRenderFns } from "./yi-user-avatar.vue?vue&type=template&id=4d9f3ecf&scoped=true&"
import script from "./yi-user-avatar.vue?vue&type=script&lang=js&"
export * from "./yi-user-avatar.vue?vue&type=script&lang=js&"
import style0 from "./yi-user-avatar.vue?vue&type=style&index=0&id=4d9f3ecf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9f3ecf",
  null
  
)

component.options.__file = "src/components/yi-user-avatar/yi-user-avatar.vue"
export default component.exports